// Phase G3 Stage 3: /parent/settings/language — redirect placeholder
// (storybook leaves this as a stub redirect to the main settings page;
// real language section ships in Phase H along with locale UX).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/parent/settings/language")({
  beforeLoad: () => {
    throw redirect({ to: "/parent/settings" });
  },
  component: () => null,
});
